import { createContext } from 'react';

import { DataQueryFormItem, DataQueryFormItemMeta } from '../pages/types';

export type QueryConfigFunction = (a: DataQueryFormItem[] | undefined) => DataQueryFormItem[] | undefined;

export type QueryConfigMetaFunction = (a: DataQueryFormItemMeta | undefined) => DataQueryFormItemMeta | undefined;

type IQueryConfigContext = {
  searchConfigs?: DataQueryFormItem[];
  previousSearches?: DataQueryFormItem[];
  removePreviousSearchConfig: (deletedSearchId: string, searchType: string) => void;
  selectPreviousSearchConfig: (candidate: DataQueryFormItem, searchType: string, routeType: string) => void;
  updateSearchConfig: (id: string, delta: string[]) => DataQueryFormItem | undefined;
  setSearchConfigs: (newSearchConfigs: DataQueryFormItem[] | QueryConfigFunction, deletedSearchConfig?: DataQueryFormItem) => void;
  updateMetaConfig: (id: string, delta: DataQueryFormItemMeta | QueryConfigMetaFunction) => void;
  loading?: boolean;
};

const queryConfigContext: IQueryConfigContext = {
  searchConfigs: [
    {
      name: 'Untitled',
      uuid: '',
      config: {
        products: [],
      },
    },
  ],
  previousSearches: [],
  removePreviousSearchConfig: () => {},
  selectPreviousSearchConfig: () => {},
  updateSearchConfig: () => undefined,
  setSearchConfigs: () => {},
  updateMetaConfig: () => {},
  loading: true,
};

export const QueryConfigContext = createContext(queryConfigContext);
